import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Button} from "@material-ui/core";
import {TRANSFER_TYPES} from "./index";
import {setTransferCallEnvironment} from "../../../reducers/globalDialerV2/globalDialerSlice";
import Utils from "../../../helpers/Utils";

const TeamList = ({ initiateSecondCalling }) => {
    const dispatch = useDispatch();
    const {teamMembers, transferCallEnvironment} = useSelector((state)=>(state.globalDialerV2));

    return (
        <div className='callTransferWrapper'>
            <div>
                <div className='contactList' style={{ marginBottom: teamMembers[0] ? 16 : 0 }}>
                    <div className='scrollBar'>
                        {
                            teamMembers.map((item, index) => {
                                if (item.id !== Utils.getAccountData('userId')){
                                    return(
                                        <div key={index} onClick={()=>{
                                            if (item.id === transferCallEnvironment.transferToUser?.id){
                                                dispatch(setTransferCallEnvironment({
                                                    transferToUser: null
                                                }));
                                            }else {
                                                dispatch(setTransferCallEnvironment({
                                                    transferToUser: item
                                                }));
                                            }
                                        }} className={`contactItem ${item.id === transferCallEnvironment.transferToUser?.id && "selected"}`}>
                                            <span className='itemTitle'>{item.full_name}</span>
                                            <span className='leftSide'>
                                            </span>
                                        </div>
                                    );
                                }
                            })
                        }
                    </div>
                </div>
            </div>
            <div className='footerSection' >
                <Button
                    style={{ backgroundColor: '#3D50FF', textTransform: 'capitalize' }}
                    variant='contained'
                    color='primary'
                    fullWidth
                    disabled={!transferCallEnvironment.transferToUser}
                    onClick={()=>initiateSecondCalling(TRANSFER_TYPES.BLIND)}
                >
                    Cold Transfer
                </Button>

                <Button
                    className='outlinedButton'
                    variant='outlined'
                    fullWidth
                    onClick={() => initiateSecondCalling(TRANSFER_TYPES.WARM)}
                    disabled={!transferCallEnvironment.transferToUser}
                >
                    Warm Transfer
                </Button>
            </div>
        </div>
    );
};

export default TeamList;